import { render, staticRenderFns } from "./ModalAssinaturaTermo.vue?vue&type=template&id=5ff155e3&"
import script from "./ModalAssinaturaTermo.vue?vue&type=script&lang=js&"
export * from "./ModalAssinaturaTermo.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssinaturaTermo.vue?vue&type=style&index=0&id=5ff155e3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports